// Mirrors the backend enum SETTLEMENT_PREFERENCE_TYPE in
// basquet-backend/src/constants/db.constant.ts. The PATCH
// /merchant/meta/settlement-preference endpoint rejects any string that
// isn't one of these three.
const SETTLEMENT_PREFERENCE_TYPES = {
  QUOTED_CURRENCY: 'QUOTED_CURRENCY',
  SPECIFIC_CURRENCY: 'SPECIFIC_CURRENCY',
  PAYMENT_CURRENCY: 'PAYMENT_CURRENCY'
};

const DEFAULT_SETTLEMENT_PREFERENCE_TYPE = SETTLEMENT_PREFERENCE_TYPES.QUOTED_CURRENCY;

// Order here is the order rendered in the UI. Titles + helper texts are
// the user-facing copy from the PRD — change here, not in the component.
const SETTLEMENT_PREFERENCE_OPTIONS = [
  {
    value: SETTLEMENT_PREFERENCE_TYPES.QUOTED_CURRENCY,
    title: 'Receive payments in quoted currency',
    description: 'You will always receive the exact amount you set on your payment link.'
  },
  {
    value: SETTLEMENT_PREFERENCE_TYPES.SPECIFIC_CURRENCY,
    title: 'Convert all payments to a selected currency',
    description: 'All payments will be converted into your chosen currency.'
  },
  {
    value: SETTLEMENT_PREFERENCE_TYPES.PAYMENT_CURRENCY,
    title: 'Preserve customer payment currency',
    description: 'You will receive payments in the same currency your customer pays.'
  }
];

/**
 * Derive the merchant's current settlement-preference mode from the
 * `/merchant/meta` payload, falling back across legacy shapes.
 *
 *  1. New column `settlement_preference_type` — authoritative when present.
 *  2. Legacy data: `settlement_currency` set → infer SPECIFIC_CURRENCY.
 *     The backend's resolveSettlementPreferenceMode does the same fallback
 *     server-side; this mirror keeps the UI consistent with pre-backfill
 *     rows that some merchants still have.
 *  3. Otherwise → default to QUOTED_CURRENCY.
 *
 * @param {{ settlement_preference_type?: string, settlement_currency?: number | string | null } | null | undefined} meta
 * @returns {string}
 */
const resolveInitialSettlementType = (meta) => {
  const mode = meta?.settlement_preference_type;
  if (mode && Object.values(SETTLEMENT_PREFERENCE_TYPES).includes(mode)) {
    return mode;
  }
  if (meta?.settlement_currency) {
    return SETTLEMENT_PREFERENCE_TYPES.SPECIFIC_CURRENCY;
  }
  return DEFAULT_SETTLEMENT_PREFERENCE_TYPE;
};

export {
  DEFAULT_SETTLEMENT_PREFERENCE_TYPE,
  resolveInitialSettlementType,
  SETTLEMENT_PREFERENCE_TYPES,
  SETTLEMENT_PREFERENCE_OPTIONS
};
